module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_square_red.2beb57b2.png";